/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_Line_ThreeInputs */

const en_highlight_settings_preview_line_three = /** @type {(inputs: Highlight_Settings_Preview_Line_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try switching modes above and adjust color below.`)
};

const es_highlight_settings_preview_line_three = /** @type {(inputs: Highlight_Settings_Preview_Line_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba otros modos y ajusta el color.`)
};

/**
* | output |
* | --- |
* | "Try switching modes above and adjust color below." |
*
* @param {Highlight_Settings_Preview_Line_ThreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_line_three = /** @type {((inputs?: Highlight_Settings_Preview_Line_ThreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_Line_ThreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_line_three(inputs)
	return en_highlight_settings_preview_line_three(inputs)
});